import {createI18n} from 'vue-i18n'

import enUS from '@/assets/locales/en-US.js'
import zhCN from '@/assets/locales/zh-CN.js'
import {getRawCookie, setRawCookie} from "@/utils/cookie/CookieUtil.js";

import usFlag from '@/assets/img/locales/us.jpg';
import cnFlag from '@/assets/img/locales/china.png';

export const _KeyCurrentLanguage = "sogate_current_language"
export const SupportedLanguageFlags = {
    US: usFlag,
    CN: cnFlag,
}
export const SupportedLanguageNames = {
    US: "English",
    ZhCN: "中文简体",
}
export const SupportedLanguageKeys = {
    US: "en-US",
    ZhCN: "zh-CN",
}

export const SupportedLanguages = [
    {
        flag: SupportedLanguageFlags.US,
        language: SupportedLanguageKeys.US,
        title: SupportedLanguageNames.US,
    },
    {
        flag: SupportedLanguageFlags.CN,
        language: SupportedLanguageKeys.ZhCN,
        title: SupportedLanguageNames.ZhCN,
    },
]

export function getCurrentLanguage() {
    return getRawCookie(_KeyCurrentLanguage) || (localStorage.getItem(_KeyCurrentLanguage)) || SupportedLanguageKeys.ZhCN
}

export function setCurrentLanguage(i18n, lang) {
    i18n.locale = lang;
    localStorage.setItem(_KeyCurrentLanguage, lang);
    setRawCookie(_KeyCurrentLanguage, lang)
    i18n.localeFlag = getCurrentLanguageFlag()
    i18n.localeName = getCurrentLanguageName()
}

export function getCurrentLanguageFlag () {
    switch (getCurrentLanguage()) {
        case SupportedLanguageKeys.US: {
            return SupportedLanguageFlags.US
        }
        case SupportedLanguageKeys.ZhCN: {
            return SupportedLanguageFlags.CN
        }
    }
    return SupportedLanguageFlags.US
}

export function getCurrentLanguageName() {
    switch (getCurrentLanguage()) {
        case SupportedLanguageKeys.US: {
            return SupportedLanguageNames.US
        }
        case SupportedLanguageKeys.ZhCN: {
            return SupportedLanguageNames.ZhCN
        }
    }
    return SupportedLanguageNames.US
}

export const i18n = createI18n({
    locale: getCurrentLanguage(),
    messages: {
        en: enUS,
        zh: zhCN
    }
})